import React, { ComponentProps, ForwardedRef, forwardRef, useEffect } from 'react';
import styled from 'styled-components';
import { up } from '../../utils/styles/breakpoints';
import { Flex } from '../layout/Flex';
import { Backdrop } from './Backdrop';

interface DrawerProps extends ComponentProps<typeof Flex> {
    onClose: VoidFunction;
}

const DrawerContainer = styled(Flex).attrs({
    direction: 'column',
    overflow: 'hidden',
    width: '100%',
    borderRadius: { sm: 3 },
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
})`
    max-height: 80vh;
    max-width: 580px;
    position: fixed;
    z-index: 1201;
    bottom: 0;

    ${up('md')} {
        position: relative;
        bottom: unset;
    }
`;

export const DrawerTitle = styled(Flex).attrs((props) => ({
    p: 2,
    overflow: 'hidden',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    direction: 'row',
    position: 'relative',
    background: 'var(--background-primary)',
    ...props,
}))``;

export const DrawerContent = styled(Flex).attrs((props) => ({
    width: '100%',
    p: { sm: 3 },
    overflowY: 'auto',
    height: { xs: '100%', sm: 'auto' },
    background: 'var(--background-primary)',
    ...props,
}))``;

export const Drawer = forwardRef((props: DrawerProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { children, ...other } = props;

    useEffect(() => {
        window.document.body.style.setProperty('overflow', 'hidden');

        return () => {
            window.document.body.style.removeProperty('overflow');
        };
    }, []);

    return (
        <Backdrop onClose={props.onClose}>
            <DrawerContainer ref={ref} {...other}>
                {children}
            </DrawerContainer>
        </Backdrop>
    );
});
